import React from 'react';

import './style.css';

export default class CidrInput extends React.Component{
    constructor(props){
        super(props);

        this.state = {value:''};
        this.onChange = this.onChange.bind(this);
    }
    onChange(e){
        const intValue = parseInt(e.target.value);
        if(intValue > 0 && intValue <= 32){
            this.setState({value:intValue});
            
            if(this.props.onChange){
                this.props.onChange(intValue);
            }
        }else{
            this.setState({value:''});
            if(this.props.onChange){
                this.props.onChange(intValue);
            }
        }
    }
    render(){
        return (
            <div className="react-ip-input">
            <input onChange={this.onChange} value={this.state.value}
              type="text"/>
            </div>
        );
    }
}